export enum ClaimEstatesStatusEnum {
  created = 'CREATED',
  inAnalysis = 'IN_ANALYSIS',
  pending = 'PENDING',
  inProgress = 'IN_PROGRESS',
  finished = 'FINISHED',
  debtConfession = 'DEBT_CONFESSION',
  inAccord = 'IN_ACCORD',
  monthlyIndemnity = 'MONTHLY_INDEMNITY',
  lmiLmgReached = 'LMI_LMG_REACHED',
  preAccident = 'PRE_ACCIDENT',
  returnBill = 'RETURN_BILL',
  draft = 'DRAFT',
  deleted = 'DELETED'
}

export const ClaimEstatesStatusLabels: Record<ClaimEstatesStatusEnum, string> = {
  [ClaimEstatesStatusEnum.created]: 'Em aberto',
  [ClaimEstatesStatusEnum.inAnalysis]: 'Em análise',
  [ClaimEstatesStatusEnum.pending]: 'Pendenciado',
  [ClaimEstatesStatusEnum.inProgress]: 'Em andamento',
  [ClaimEstatesStatusEnum.finished]: 'Finalizado',
  [ClaimEstatesStatusEnum.debtConfession]: 'Confissão de Dívida',
  [ClaimEstatesStatusEnum.inAccord]: 'Em acordo',
  [ClaimEstatesStatusEnum.monthlyIndemnity]: 'Indenizado mensalmente',
  [ClaimEstatesStatusEnum.lmiLmgReached]: 'LMI/LMG atingido',
  [ClaimEstatesStatusEnum.preAccident]: 'Pré-sinistro',
  [ClaimEstatesStatusEnum.returnBill]: 'Boleto Devolutivo',
  [ClaimEstatesStatusEnum.draft]: 'Rascunho',
  [ClaimEstatesStatusEnum.deleted]: 'Excluído'
};
